/**
 * SKE-5310. The question asked when a System User login found nothing: connect
 * with the User-token configuration instead? Asked from the shared login layer,
 * answered by `ConnectAnotherWayPrompt`, which root.tsx mounts once.
 */

type Listener = () => void;

let pending: ((accept: boolean) => void) | null = null;
const listeners = new Set<Listener>();

function notify() {
  for (const listener of listeners) listener();
}

export function subscribeConnectAnotherWay(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
    // Nothing left to answer an open question, so it counts as dismissed.
    if (listeners.size === 0) answerConnectAnotherWay(false);
  };
}

export function isConnectAnotherWayOpen(): boolean {
  return pending !== null;
}

/** Resolves true when the person chooses to connect another way. */
export function askToConnectAnotherWay(): Promise<boolean> {
  if (listeners.size === 0) {
    console.warn(
      "Connect another way prompt is not mounted; keeping the first login's result."
    );
    return Promise.resolve(false);
  }
  // One question at a time: an earlier one still open counts as dismissed.
  pending?.(false);
  return new Promise<boolean>((resolve) => {
    pending = resolve;
    notify();
  });
}

export function answerConnectAnotherWay(accept: boolean): void {
  const resolve = pending;
  pending = null;
  notify();
  resolve?.(accept);
}
